import React, {Component} from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '../../../components/button';
import Can from '../../../components/can';

const scopeLabel = (scope) => (scope.type === 'global' ? 'global' : `${scope.type}:${scope.id}`);

/** `GET /access/assignments?subjectId=` — with revoke (docs/access/slice-4b-admin-surface-plan.md §5). */
class AssignmentTable extends Component {
  render() {
    const {assignments, onGrant, onRevoke} = this.props;
    const rows = assignments || [];

    return (
      <div className="rounded-card assignments-panel">
        <div className="panel-header">
          <h3>Assignments</h3>
          <Can code="access:grant" module="/access">
            <Button label="+ Grant" className="btn btn-action" onClick={onGrant} data-testid="ac-grant-open" />
          </Can>
        </div>
        <Table size="small" className="data-table">
          <TableHead>
            <TableRow>
              <TableCell><strong>Role / Permission</strong></TableCell>
              <TableCell><strong>Scope</strong></TableCell>
              <TableCell><strong>Expires</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {!rows.length && (
              <TableRow>
                <TableCell colSpan={5} data-testid="ac-empty">No assignments for this subject.</TableCell>
              </TableRow>
            )}
            {rows.map((a) => (
              // listAssignments returns every assignment ever granted, active or historical — a
              // status column is load-bearing, not decorative: without it a revoked
              // legacy_super@global renders identically to a live one, and after the flip "no ✕"
              // means either revoked or not-permitted (Can hides it too), which this disambiguates.
              <TableRow key={a.assignmentId} hover data-testid="ac-assignment-row" className={a.revokedAt ? 'revoked' : ''}>
                <TableCell>{a.roleCode || a.permissionCode}</TableCell>
                <TableCell>{(a.scopes || []).map(scopeLabel).join(', ') || '—'}</TableCell>
                <TableCell>{a.expiresAt ? new Date(a.expiresAt).toLocaleDateString() : '—'}</TableCell>
                <TableCell data-testid="ac-assignment-status">{a.revokedAt ? 'Revoked' : 'Active'}</TableCell>
                <TableCell>
                  {!a.revokedAt && (
                    <Can code="access:revoke" module="/access">
                      <Button
                        label="✕" className="btn btn-default" data-testid="ac-assignment-revoke"
                        onClick={() => onRevoke(a.assignmentId)}
                      />
                    </Can>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default AssignmentTable;
